













import {Step} from "@/components/infrastructures/molecules/StepContents.vue";
import {Component, Vue} from "vue-property-decorator";
import ForgotPasswordConfirmMailForm
  from "@/components/domains/account/forgot_password/steps/ForgotPasswordConfirmMailForm.vue";
import ForgotPasswordResetPasswordForm
  from "@/components/domains/account/forgot_password/steps/ForgotPasswordResetPasswordForm.vue";
import ContentTitle from "@/components/infrastructures/atoms/designed/ContentTitle.vue";
import DefaultTemplate from "@/components/templates/default/DefaultTemplate.vue";
import PasswordRetiredNotice from "@/components/domains/account/passwordless/PasswordRetiredNotice.vue";
import {loadAuthPolicy} from "@/components/domains/account/passwordless/passwordlessService";

@Component({
  components: {DefaultTemplate, ContentTitle, PasswordRetiredNotice}
})
export default class ForgotPasswordPage extends Vue {

  name = "ForgotPasswordPage";

  steps: Step[] = [];
  createdStep = false;
  retired = false;

  mounted() {
    loadAuthPolicy({fresh: true}).then((policy) => {
      if (!policy.passwordLoginAllowed) {
        this.retired = true;
        return;
      }
      this.steps = [
        new ForgotPasswordConfirmMailForm(),
        new ForgotPasswordResetPasswordForm()
      ];
      this.createdStep = true;
    });
  }
}
